import { Box, Divider, FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import DesignationSelect from "../../utils/designationSelect";

// Converts dd-MM-yyyy (stored) → yyyy-MM-dd (for HTML date input display)
const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
};

// Converts yyyy-MM-dd (from HTML date input) → dd-MM-yyyy (for storage / backend)
const formatDateForStorage = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
};


const ExtensionLetterForm = ({ data, setData }) => {

    const handleChange = (key, value) => {
        if (
            key === "extension_date" || key === "original_start_date" || key === "original_end_date"
            || key === "effective_start_date" || key === "effective_end_date"
        ) {
            value = formatDateForStorage(value);
        }

        setData(prev => ({
            ...prev,
            [key]: value
        }));
    };

    return (
        <Box sx={{ mt: 1 }}>



            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                    gap: 2
                }}
            >
                <Box>
                    <TextField
                        type="date"
                        label="Extension Date"
                        fullWidth
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        value={data.extension_date ? formatDateForInput(data.extension_date) : ""}
                        onChange={(e) => handleChange("extension_date", e.target.value)}
                    />
                </Box>

                <Box>
                    <DesignationSelect
                        value={data.designation || ""}
                        onChange={(e) => handleChange("designation", e.target.value)}
                    />
                </Box>

                <Box>
                    <FormControl fullWidth>
                        <InputLabel id="department-label">Department</InputLabel>
                        <Select
                            labelId="department-label"
                            label="Department"
                            value={data.department_name || ""}
                            onChange={(e) => handleChange("department_name", e.target.value)}
                        >
                            <MenuItem value="Admin">Admin</MenuItem>
                            <MenuItem value="Accounting">Accounting</MenuItem>
                            <MenuItem value="Bookkeeping">Bookkeeping</MenuItem>
                            <MenuItem value="Payroll">Payroll</MenuItem>
                            <MenuItem value="Audit">Audit</MenuItem>
                            <MenuItem value="Marketing">Marketing</MenuItem>
                            <MenuItem value="IT">IT</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <Box>
                    <TextField
                        type="date"
                        label="Original Start Date"
                        fullWidth
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        value={data.original_start_date ? formatDateForInput(data.original_start_date) : ""}
                        onChange={(e) => handleChange("original_start_date", e.target.value)}
                    />
                </Box>

                <Box>
                    <TextField
                        type="date"
                        label="Original End Date"
                        fullWidth
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        value={data.original_end_date ? formatDateForInput(data.original_end_date) : ""}
                        onChange={(e) => handleChange("original_end_date", e.target.value)}
                    />
                </Box>

                <Box>
                    <TextField
                        type="number"
                        label="Total Leave"
                        fullWidth
                        value={data.total_leave || ""}
                        onChange={(e) => handleChange("total_leave", e.target.value)}
                        sx={{
                            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                WebkitAppearance: "none",
                                margin: 0,
                            },
                            "& input[type=number]": {
                                MozAppearance: "textfield",
                            },
                        }}
                        slotProps={{
                            input: {
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Divider
                                            sx={{ height: 28, m: 0.5, mr: 1 }}
                                            orientation="vertical"
                                        />
                                        <Select
                                            value={data.duration || ""}
                                            onChange={(e) => handleChange("duration", e.target.value)}
                                            variant="standard"
                                            disableUnderline
                                            sx={{
                                                width: "5.3125rem",
                                                "& .MuiSelect-select": { py: 1 }
                                            }}
                                        >
                                            <MenuItem value="days">Days</MenuItem>
                                            <MenuItem value="months">Months</MenuItem>
                                        </Select>
                                    </InputAdornment>
                                ),
                            },
                        }}
                    />
                </Box>

                <Box>
                    <TextField
                        type="number"
                        label="Number Of Months"
                        fullWidth
                        value={data.number_of_months || ""}
                        onChange={(e) => handleChange("number_of_months", e.target.value)}
                    />
                </Box>

                <Box>
                    <TextField
                        type="date"
                        label="Effective Start Date"
                        fullWidth
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        value={data.effective_start_date ? formatDateForInput(data.effective_start_date) : ""}
                        onChange={(e) => handleChange("effective_start_date", e.target.value)}
                    />
                </Box>

                <Box>
                    <TextField
                        type="date"
                        label="Effective End Date"
                        fullWidth
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        value={data.effective_end_date ? formatDateForInput(data.effective_end_date) : ""}
                        onChange={(e) => handleChange("effective_end_date", e.target.value)}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default ExtensionLetterForm;
